import React from 'react';
import { Edit2Liner24 } from 'seagull/icons';
import styles from "./EditableTableCell.module.scss";
export default function EditableTableCell(props) {
  const {
    children,
    testid,
    onClick
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.button,
    onClick: onClick,
    "data-testid": testid
  }, /*#__PURE__*/React.createElement("div", null, children), /*#__PURE__*/React.createElement("div", {
    className: styles.icon
  }, /*#__PURE__*/React.createElement(Edit2Liner24, null))));
}